export default ['BHD', 'JOD', 'TND', 'OMR']
